export default "__VITE_ASSET__DZZgoS7O__"